import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Expertise from "./components/Expertise";
import Companies from "./components/Companies";
import Clients from "./components/Clients";
import Industries from "./components/Industries";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Expertise />
        <Companies />
        <Clients />
        <Industries />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}